import React from "react"
import _ from "lodash"
import trcss from "../../../styles/Telerecovery.module.css"
import { Tooltip } from 'primereact/tooltip'
import { formatDate, getTimeAgo } from "../Utils"

export default function BroadcastMessage({ message }) {

  const dateClass = formatDate(message.updatedAt, "MMMMdyyyyhmms")

  return (
    <div style={{ marginBottom: "15px" }}>
      <div className={trcss.messageData}
        style={{
          justifyContent: "flex-end",
          marginBottom: "5px"
        }}
      >
        <span className={trcss.messageDataTime}>
          {getTimeAgo(message.createdAt)}
        </span>
      </div>
      <div style={{ float: "right" }} className={trcss.chatMessageBody}>
        <div>
          <div
            className={trcss.myMessage + " " + dateClass}
          >
            {message.message}
          </div>
          <Tooltip
            target={"." + dateClass}
            className="custom-tooltip"
            position="top"
          >
            <span>
              {formatDate(message.updatedAt, "MMMM d yyyy, h:mm:ss a")}
            </span>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}